import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'humanReadableSeconds',
})
export class HumanReadableSecondsPipe implements PipeTransform {
  // shows seconds as a string of human readable time in hours, minutes and seconds
  transform(fullSeconds: number) {
    if (!fullSeconds) {
      return '0 uur';
    }

    const hours = Math.floor(fullSeconds / 60 / 60);
    const minutes = Math.floor(fullSeconds / 60) % 60;
    const seconds = fullSeconds % 60;

    const strParts: string[] = [];
    if (hours) {
      strParts.push(`${hours} uur`);
    }
    if (minutes) {
      strParts.push(`${minutes} minuten`);
    }
    if (seconds) {
      strParts.push(`${seconds} seconden`);
    }

    const endStr = strParts.pop();
    const startStr = strParts.join(', ');

    if (startStr) {
      return `${startStr} en ${endStr}`;
    } else {
      return endStr;
    }
  }
}
